<template>
    <div class="container-box">
        <div class="main-section-background">
            <div class="main-section">
                <img src="@/assets/logo2.png" class="logo" alt="">
                <h1>
                    {{ $t('referralInfoBox.mainText') }}
                </h1>
            </div>
        </div>
        <div class="footer-section">
            <img src="@/assets/megaphone.svg">
            <span>
                {{ $t('referralInfoBox.seondaryText') }}
            </span>
        </div>
    </div>
</template>

<script>
    export default {
    }
</script>

<style scoped>
.container-box {
    width: 100%;
    background: rgba(255, 255, 255, .74);
    backdrop-filter: blur(13px);
    border-radius: 27px;
    box-shadow: 0px 3px 6px #00000029;
    padding-bottom: 50px;
    overflow: hidden;
}
.main-section {
    background: rgba(255, 255, 255, .8);
    clip-path: polygon(100% 0, 100% 94%, 0 100%, 0 0);
    padding-bottom: 30px;
    padding: 3rem;
}
.main-section-background {
    background: rgba(255, 255, 255, .4);
    clip-path: polygon(100% 0, 100% 90%, 0 100%, 0 0);
    padding-bottom: 80px;
}
.main-sections::before {
    content: "";
    position: absolute;
    width: 100%;
    height: 390px;
    top: 0;
    left: 0;
    z-index: -1;
    background: rgba(255, 255, 255, .8);
    transform: rotate(-2deg);
}
h1 {
    font-size: 2rem;
    font-family: 'RobotoBold';
    margin-bottom: 3rem;
    white-space: pre-line;
}
.footer-section {
    display: flex;
    width: 83%;
    margin: auto;
    margin-top: .5rem;
}
.footer-section span {
    font-size: 2.25rem;
    margin-left: 10%;
    align-self: center;
}
.logo {
    width: 10%;
    height: auto;
    margin-top: -1rem;
}
@media screen and (max-width: 1870px) {
    h1 {
        font-size: 2rem;
        margin-bottom: 1.5rem;
    }
    .footer-section span {
        font-size: 1.9rem;
    }
    .footer-section {
        width: 93%;
    }
}
@media screen and (max-width: 1490px) {
    h1 {
        font-size: 1.8rem;
    }
}

/* @media screen and (max-width: 1520px) {
    h1 {
        font-size: 2.2rem;
        margin-bottom: 1.5rem;
    }
    .footer-section span {
        font-size: 1.9rem;
    }
    .footer-section {
        width: 93%;
    }
} */
@media screen and (max-width: 1150px) {
    h1 {
        font-size: 2.2rem;
        margin-bottom: 1.5rem;
    }
    .footer-section span {
        font-size: 1.45rem;
    }
    .footer-section {
        width: 95%;
    }

}

@media screen and (max-width: 768px) {
    .logo {
        width: 15%;
    }
    .main-section {
        padding: 2.3rem;
    }
     h1 {
        font-size: 1.4rem;
        margin-bottom: 0rem;
    }
    .footer-section span {
        font-size: 1rem;
        margin-left: 5%;
    }
    .footer-section {
        width: 95%;
        margin-top: 1rem;
        margin-bottom: -40px;
    }
    .footer-section img {
        width: 120px;
    }

    .main-section-background {
        padding-bottom: 40px;
    }
    .main-section {
        padding-bottom: 20px;
    }
}

@media screen and (max-width: 528px) {
    .logo {
        width: 20%;
    }
    .main-section {
        padding: 1.8rem;
    }
     h1 {
        font-size: .9rem;
        margin-bottom: 0rem;
    }
    .footer-section span {
        font-size: .9rem;
        margin-left: 5%;
    }
    .footer-section {
        width: 95%;
        margin-top: 0rem;
    }
    .footer-section img {
        width: 80px;
    }

    .main-section-background {
        padding-bottom: 40px;
    }
    .main-section {
        padding-bottom: 20px;
    }
}

@media screen and (min-height: 789px) {
    h1 {
        font-size: 1.6rem;
        margin-bottom: 0;
    }
    .fsooter-section span {
        font-size: 1.6rem;
    }
    .disclaimer {
        margin-bottom: -1.5em;
        margin-top: -.8em;
    }
}
</style>
